import React from 'react';
import { Box, Typography, Stack, Paper, Link as MuiLink, IconButton } from '@mui/material';
import { Link } from 'react-router';
import { ExpensePaymentFragmentFragment } from '../generated/graphql';
import { useApp } from './app-context';
import { appPaths } from '../app-paths';
import { RemoveItemIcon } from './icons';

interface ExpensePaymentListProps {
  payments: ExpensePaymentFragmentFragment[];
  context: 'expense' | 'transaction';
  onRemove?: (paymentId: string) => void;
}

export function ExpensePaymentList({ payments, context, onRemove }: ExpensePaymentListProps) {
  const app = useApp();

  const activePayments = payments.filter((a) => !a.deletedAt);

  if (!activePayments || activePayments.length === 0) {
    return (
      <Box>
        <Typography variant="body2" color="text.secondary">
          Žiadne priradené platby
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={1}>
      {activePayments.map((payment) => (
        <Paper key={payment.id} variant="outlined" sx={{ p: 1.5 }}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={1}>
            {onRemove && (
              <IconButton onClick={() => onRemove(payment.id)} title="Odstrániť priradenie">
                <RemoveItemIcon fontSize="small" />
              </IconButton>
            )}
            <Stack spacing={1} sx={{ flex: 1 }} direction={'row'}>
              <Typography variant="caption" color="text.secondary">
                {app.formatDate(payment.createdAt)}
              </Typography>
              <Typography variant="body2">
                <strong>{app.formatNumber(payment.amount, 2)} €</strong>
              </Typography>
              {context === 'expense' && payment.transactionId && (
                <MuiLink
                  component={Link}
                  to={appPaths.moneyTransactionList.navigate()}
                  variant="caption"
                  underline="hover"
                >
                  Transakcia (zobraziť zoznam)
                </MuiLink>
              )}
              {context === 'transaction' && payment.expense && (
                <MuiLink
                  component={Link}
                  to={appPaths.expense.navigate({ expenseId: payment.expenseId })}
                  variant="caption"
                  underline="hover"
                >
                  {payment.expense.title}
                </MuiLink>
              )}
            </Stack>
          </Stack>
        </Paper>
      ))}
    </Stack>
  );
}
